import React from 'react'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const AgencyProducerNotFound = () => (
  <section>
    <header>
      <PageTitle>
        External project manager not found!
      </PageTitle>
    </header>
    <br/>
    <BackButton/>
  </section>
)

export default AgencyProducerNotFound



// WEBPACK FOOTER //
// ./src/components/AgencyProducers/AgencyProducerNotFound.jsx